module.exports = __webpack_public_path__ + "media/images/Download Centre/Thumbnails/Picture14-5b20b95583b41679961fe2f3fa625dde.jpg";